import { cn } from '../../utils/cn';

export function QuickCreateField({ label, optional, children, className }) {
  return (
    <div className={cn('flex flex-col gap-space-2', className)}>
      <span className="type-label text-foreground">
        {label}
        {optional ? (
          <span className="font-normal text-muted-foreground"> {optional}</span>
        ) : null}
      </span>
      {children}
    </div>
  );
}
